// src/pages/PDFViewerPage.js
import React, { useEffect } from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PDFViewer from '../components/players/PDFViewer';

const PDFViewerPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const stateData = location.state || {};
  const fileUrl = stateData.fileUrl || searchParams.get('url') || '';
  const mediaId = stateData.mediaId || searchParams.get('mediaId') || null;
  const title = stateData.title || searchParams.get('title') || '';

  useEffect(() => {
    if (!fileUrl && !mediaId) {
      navigate(-1);
    }
  }, [fileUrl, mediaId, navigate]);

  if (!fileUrl && !mediaId) {
    return null;
  }

  return (
    <div className="h-screen bg-gray-100 flex flex-col">
      {/* هدر با پس‌زمینه سفید، متن teal-800 و دکمه بازگشت */}
      <div className="bg-white p-3 flex items-center gap-3 shadow-sm border-b border-teal-200">
        <button
          onClick={() => navigate(-1)}
          className="text-teal-800 hover:text-teal-600 transition-colors p-2 rounded-lg hover:bg-teal-50"
          aria-label="بازگشت"
        >
          <ArrowLeft size={28} />
        </button>
        <h1 className="text-teal-800 text-lg font-semibold truncate">
          {title || 'مشاهده کتاب'}
        </h1>
      </div>
      
      {/* PDF Viewer */}
      <div className="flex-1">
        <PDFViewer
          mediaId={mediaId}
          fileUrl={fileUrl}
          title={title}
        />
      </div>
    </div>
  );
};

export default PDFViewerPage;